import { ref } from 'vue'
import i18n from '@/languages/i18n'

export const withProps = () => ({
  email: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    required: true,
  },
  lists: {
    type: Array,
  },
  logo: {
    type: String,
  },
  attrs: {
    type: Object,
  },
  customerId: {
    type: String,
  },
  saved: {
    type: Boolean,
    default: false,
  },
  saveStatus: {
    type: String,
    default: 'idle',
  },
  data: {
    type: Object,
  },
  currentStep: {
    type: String,
  },
  disabled: {
    type: Boolean,
  },
  preview: {
    type: Boolean,
    default: false,
  },
})

export function usePreferenceTemplate(props, emit) {
  const { t } = { t: i18n.global.t }
  const alertMsg = ref('')
  const chosenEmail = ref(props.email)
  const newEmail = ref('')
  const modal = ref(false)
  const modalType = ref('')

  function showAlert(msg) {
    alertMsg.value = msg
  }
  async function validatePrefEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailPattern.test(email)
  }
  async function setEmail(e, email) {
    const validEmail = await validatePrefEmail(email)
    e.preventDefault()
    if (!email || !validEmail) {
      showAlert(t('pref_template.error_invalid'))
    } else {
      emit('userEmail', { email })
    }
  }

  function editEmail() {
    modalType.value = 'email'
    modal.value = !modal.value
  }

  function updateEmail(updatedEmail) {
    modal.value = false
    newEmail.value = updatedEmail
    alertMsg.value = t('pref_page.email_updated_msg') || 'Email updated!'
    chosenEmail.value = updatedEmail
    emit('save')
  }

  function updateGlobal() {
    props.lists.forEach((list) => {
      if (list.type !== 'separator') list.subscribed = false
    })
    if (props.attrs?.auto_save) {
      emit('save')
    }
  }

  function savePreferences() {
    alertMsg.value = props.attrs?.saved_preferences_msg || t('pref_page.save_msg') || 'Your preferences have been saved'
    emit('save')
  }

  return { t, alertMsg, chosenEmail, newEmail, modal, modalType, setEmail, editEmail, updateEmail, updateGlobal, savePreferences }
}
